import { Command, ICommandResult } from '@/_core/cqrs/types/commands';

export class UpdateProfileCommand extends Command<IUpdateProfileResult> {
    constructor(public Name: string, public Email: string, public SubscribeToNewsletter: boolean) {
        super('UpdateProfile');
    }
}

type IUpdateProfileResult = ICommandResult;

export class CancelPendingEmailChangeRequestCommand extends Command<ICommandResult> {
    constructor() {
        super('CancelPendingEmailChangeRequest');
    }
}

export class ChangePassword extends Command<ChangePasswordResult> {
    constructor(public NewPassword: string, public CurrentPassword: string) {
        super('ChangePassword');
    }
}

interface ChangePasswordResult extends ICommandResult {
    IsCurrentPasswordInvalid: boolean;
}

export class DeleteUserAccountCommand extends Command<DeleteUserAccountResult> {
    constructor() {
        super('DeleteUserAccount');
    }
}

interface DeleteUserAccountResult extends ICommandResult {
    Workspaces: string;
    Domains: string;
}

export class ResendEmailAddressConfirmationEmail extends Command<ICommandResult> {
    constructor() {
        super('ResendEmailAddressConfirmationEmail');
    }
}

export class GenerateApiToken extends Command<GenerateApiTokenResult> {
    constructor() {
        super('GenerateApiToken');
    }
}

interface GenerateApiTokenResult extends ICommandResult {
    ApiToken: string;
    ApiTokenGeneratedAt: Date;
}

export class RevokeApiToken extends Command<ICommandResult> {
    constructor() {
        super('RevokeApiToken');
    }
}

